import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import SimpleBar from 'simplebar-react'

export const TaskList = styled(SimpleBar)`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-top: -${Spacing.S4};
  margin-right: -${Spacing.S4};
  padding-right: ${Spacing.S4};
  overflow: auto;
  list-style-type: none; /* important when using SimpleBar */
`
